import BillingsOrderForwardRelatedTaxiTaxiRequest from "../../../../../api/raily/billings/order-forward/related/taxi-taxi/billings-order-forward-related-taxi-taxi.request";
import BillingsOrderForwardRelatedTaxiTaxiParams from "./billings-order-forward-related-taxi-taxi-params";

const create = (
  params: BillingsOrderForwardRelatedTaxiTaxiParams,
): BillingsOrderForwardRelatedTaxiTaxiRequest => {
  return {
    forwardingId: params.forwardingUuid,
  };
};

const billingsOrderForwardRelatedTaxiTaxiParamsFactory = {
  create,
};

export default billingsOrderForwardRelatedTaxiTaxiParamsFactory;
